import type { CropSide } from '~/features/editor/slice';
import { clamp } from '~/lib/utils';
import type { Rect } from '~/types/pipeline';
import { MIN_CROP_SIZE } from './constants';

/**
 * Move one edge of a crop rect to `edge` (an absolute coord on the side's axis),
 * clamping against image bounds and `MIN_CROP_SIZE`. Shared between pointer
 * drag in `CropEdge` and keyboard nudge in `useNudge` so the two interactions
 * agree on geometry and constraints.
 */
export function resizeCropEdge(
  crop: Rect,
  dims: { w: number; h: number },
  side: CropSide,
  edge: number,
): Rect {
  if (side === 'left') {
    const x = clamp(0, crop.x + crop.w - MIN_CROP_SIZE, edge);
    return { x, y: crop.y, w: crop.x + crop.w - x, h: crop.h };
  }
  if (side === 'right') {
    const right = clamp(crop.x + MIN_CROP_SIZE, dims.w, edge);
    return { x: crop.x, y: crop.y, w: right - crop.x, h: crop.h };
  }
  if (side === 'top') {
    const y = clamp(0, crop.y + crop.h - MIN_CROP_SIZE, edge);
    return { x: crop.x, y, w: crop.w, h: crop.y + crop.h - y };
  }
  const bottom = clamp(crop.y + MIN_CROP_SIZE, dims.h, edge);
  return { x: crop.x, y: crop.y, w: crop.w, h: bottom - crop.y };
}
